import store from '@/store';
import { AxiosResponse } from 'axios';

const SERVER_TIME_HEADER = 'x-server-time';

export default function syncTimerWithServerTime(response?: AxiosResponse): void {
  const headers = response && response.headers;

  if (!headers) {
    return;
  }

  const utcNowInSeconds = Number(headers[SERVER_TIME_HEADER]);

  if (!Number.isFinite(utcNowInSeconds) || utcNowInSeconds <= 0) {
    return;
  }

  store.dispatch('timer/startTimer', utcNowInSeconds);
}
